import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import Joi from 'joi-browser';

import EventMg, { EventType } from '../utilities/EventManager';
import * as api from '../services/FieldTree';
import _dialogLoader from '../utilities/dialogLoader';
import * as dialog from '../components/FieldTreeDialog';
import urlParamManger from '../utilities/urlParamManager';
import { FIELD_TREE_PARTNER_BOX } from '../components/FieldTreePartnerBoxEvents';
import FieldService from '../services/Fields';
import FieldTreeService from '../services/FieldTrees';
import UsersApi from '../services/users/UsersApi';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import regex from '../utilities/validateRegex';
import {
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  HEADER_CONSTANTS,
  INTEGRATE_USER_SUCCESS_MESSAGE,
  INTEGRATE_USER_SUCCESS_TITLE,
  USER_ROLES,
} from '../utilities/constants';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import {
  isForemanRoleId,
  isPartnerRoleId,
  roleIdToRoleName,
  isPartnerCompanyRoleId,
} from '../utilities/roleUtility';
import {
  joinTel,
  formatTel,
  isNullOrUndefinedOrEmptyStr,
} from '../utilities/stringUtil';
import Confirmation from '../components/modals/common/Confirmation';
import { MasterPageHeader } from '../components/PageHeader';
import { validateByJoi } from '../utilities/validation';
import { TreePartnerUserForm } from '../components/forms/TreePartnerUserForm';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import { ConfirmExistedEmailDialog } from '../components/modals/ConfirmExistedEmailDialog';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { ConfirmIntegrateUserDialog } from '../components/modals/ConfirmIntegrateUserDialog';
import { IntegrateError } from '../components/modals/IntegrateError';
import { Information } from '../components/modals/common';
import EventManager from '../utilities/EventManager';
import { ForemanRegistConfirmDialog } from '../components/modals/ForemanRegistConfirmDialog';

/**
 * 「職長新規登録」画面
 * 編集画面でも使用
 * 画面遷移
 *  1.  施工体系図 > 協力会社BOX > ユーザー招待 > 新規作成 > 職長新規登録
 */
export default class FieldTreePartnerUserForm extends React.Component {
  constructor(props) {
    super(props);

    /**
     * パースした結果下記のプロパティが使用できる
     * {number} id : FieldTreeService.decideCompanyBranchId で得られる役職取得用支店ID
     * {number} prev_id : 施工体系図で選択した協力会社BOXID（field_tree_idとの違いは不明）
     * {number} field_id : 施工体系図を開いたときの現場ID
     * {number} field_tree_id : 施工体系図で選択した協力会社BOXID
     * {number} company_id : 施工体系図で選択した協力会社BOXの会社ID
     * {number} company_branch_id : 施工体系図で選択した協力会社BOXの支店ID
     * {string} form_type : （職長新規作成の時のみ）'default'固定
     * {number} user_id : 職長、協力会社管理者編集の時のみ設定されているが、パース後は"0"固定になっている
     */
    const decoded = JSON.parse(decodeURIComponent(this.props.view.state.id));
    this.schema = null;
    this.state = _.merge(decoded, {
      field_id: decoded.field_id,
      data: {
        user: {
          role_code: USER_ROLES.foreman.id, //職長
          // undefined見える対策
          name_sei: '',
          name_mei: '',
        },
        field_tree_user_jobs: [],
      },

      requiredInput: {
        // 必須入力項目
        columns: [],
        // 必須総数
        total: 0,
        count: 1, // 入力数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      formValues: {
        role_code: USER_ROLES.foreman.id, //職長
        role_name: '',
        name_sei: '',
        name_mei: '',
        kana_sei: '',
        kana_mei: '',
        tel: '',
        tel1: '',
        tel2: '',
        tel3: '',
        email: '',
        login_id: '',
        company_name: '',
        field_tree_user_jobs: [{ job_id: 0, job_name: '職種を選択' }],
        work_history_exists: true,
        partner_company_branch_id: decoded.partner_company_branch_id,
        inviter_company_name: '',
        inviter_user_fullname: '',
        created_at: null,
        blocked_on: null,
        blocked_at: null,
        field_accessible_at: null,
        approval_flag: null,
      },
      companyAddress: '',
      disabledFields: [],
      user_id: 0,

      category_type: urlParamManger.getCategoryType(),
      work_history_exists: true,
      showConfirmation: false,
      showConfirmExistedEmailDialog: false,
      showConfirmIntegrateUserDialog: false,
      showIntegrateError: false,
      showInformationModal: false,
      informationModal: null,
      integrateErrorMessage: null,
      listIntegrateUsers: null,
      isManagerPermission: false,
    });

    this.schemaDefinition = {};

    this.isNewMode = this.state.id === 0;

    this.form = {
      set: this.setData,
      isValid: this.isValid,
    };

    this.updatingFlag = false; // 多重更新防止Flag
    this.errorMessage = '';

    this.companyId = SessionStorageService.getCompanyId();
    this.userId = LocalStorageService.getUserId();
    this.roleId = LocalStorageService.getRoleId();
    this.isTargetRoleId = isPartnerCompanyRoleId(this.roleId);
    this.tempParamFetch = null;
  }

  async componentDidMount() {
    await this.settingPermission();

    //現場情報
    FieldService.info(this.state.field_id).then(response => {
      if (response.result) {
        EventMg.trigger(EventType.CURRENT_FIELD, response.data.entities.field);
      }
    });

    await this.getFieldTreeCompany();

    let requiredFields = [];
    let count = 0;

    // ユーザ詳細
    // 編集可能なのは「職種」だけ
    if (!this.isNewMode) {
      ///api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/:id
      FieldTreeService.show(
        this.state.field_id,
        this.state.field_tree_id,
        this.state.id
      ).then(data => {
        if (data.result && data.data.entities) {
          const { field_tree_user: fieldTreeUser } = data.data.entities;

          // アカウントが停止中の場合「表示権限エラー画面に遷移する」
          if (fieldTreeUser.block_flag === 1) {
            return (document.location.href = '/error-permission');
          }

          const [tel1, tel2, tel3] = isNullOrUndefinedOrEmptyStr(
            fieldTreeUser.tel
          )
            ? ['', '', '']
            : fieldTreeUser.tel.split('-');

          const workHistoryExists = _.chain(fieldTreeUser.work_history_exists)
            .values()
            .filter(value => {
              return value === true;
            })
            .value();

          const disabledFields = [
            'name_sei',
            'name_mei',
            'kana_sei',
            'kana_mei',
            'tel1',
            'tel2',
            'tel3',
            'email',
            'login_id',
          ];

          // If the current user is foreman then able to edit job_id
          if (
            _.isNumber(fieldTreeUser.role_code) &&
            isForemanRoleId(fieldTreeUser.role_code)
          ) {
            requiredFields = [...requiredFields, 'job_id'];
            this.schemaDefinition = {
              job_id: Joi.array()
                .required()
                .min(1)
                .error(() => ({
                  type: 'validation.custom',
                  message: '未入力です',
                })),
            };
            this.schema = Joi.object().keys(this.schemaDefinition);
          }

          this.setState(
            {
              user_id: fieldTreeUser.user_id,
              data: {
                ...this.state.data,
                user: {
                  user_id: fieldTreeUser.user_id,
                  role_code: fieldTreeUser.role_code,
                  name_sei: fieldTreeUser.user_name_sei,
                  name_mei: fieldTreeUser.user_name_mei,
                },
              },
              formValues: {
                ...this.state.formValues,
                id: fieldTreeUser.id,
                role_code: fieldTreeUser.role_code, //職長
                email: fieldTreeUser.email,
                role_name: _.filter(USER_ROLES, v => {
                  return v.id === fieldTreeUser.role_code;
                })[0].name,
                integrated: fieldTreeUser.integrated,
                name_sei: fieldTreeUser.user_name_sei,
                name_mei: fieldTreeUser.user_name_mei,
                kana_sei: _.has(fieldTreeUser, 'user_kana_sei')
                  ? fieldTreeUser.user_kana_sei
                  : '',
                kana_mei: _.has(fieldTreeUser, 'user_kana_mei')
                  ? fieldTreeUser.user_kana_mei
                  : '',
                tel: fieldTreeUser.tel,
                login_id: fieldTreeUser.login_id,
                company_name: fieldTreeUser.company_name,
                field_tree_user_jobs: fieldTreeUser.field_tree_user_jobs,
                work_history_exists: !!workHistoryExists.length,
                tel1,
                tel2,
                tel3,
                ..._.pick(fieldTreeUser, [
                  'inviter_company_name',
                  'inviter_user_fullname',
                  'created_at',
                  'blocked_on',
                  'blocked_at',
                  'field_accessible_at',
                ]),
              },
              requiredInput: {
                // 必須入力項目
                columns: requiredFields,
                // 必須総数
                total: _.size(requiredFields),
                count, // 入力数
              },
              disabledFields,
            },
            () => {
              this.setData(
                'field_tree_user_jobs',
                fieldTreeUser.field_tree_user_jobs
              );
            }
          );
        }
      });
    } else {
      this.schemaDefinition = {
        job_id: Joi.array()
          .required()
          .min(1)
          .error(() => ({
            type: 'validation.custom',
            message: '未入力です',
          })),
        name_sei: Joi.string()
          .required()
          .max(64),
        name_mei: Joi.string()
          .required()
          .max(64),
        kana_sei: Joi.string()
          .max(128)
          .regex(regex.pattern.hiragana)
          .required()
          .label('hiragana'),
        kana_mei: Joi.string()
          .max(128)
          .regex(regex.pattern.hiragana)
          .required()
          .label('hiragana'),
        login_id: Joi.string()
          .max(60)
          .regex(regex.pattern.pwd)
          .required()
          .label('pwd'),
        tel: Joi.string()
          .regex(regex.pattern.tel)
          .allow('', '--'),
        email: Joi.string()
          .regex(regex.pattern.email)
          .allow(''),
      };

      requiredFields = [
        ...requiredFields,
        'job_id',
        'name_sei',
        'name_mei',
        'kana_sei',
        'kana_mei',
        'login_id',
      ];
      const company_id = _.get(this.state, 'formValues.company_id');
      if (
        !_.isUndefined(company_id) &&
        this.isNewMode &&
        this.state.isManagerPermission &&
        this.isTargetRoleId &&
        Number(company_id) === Number(this.companyId)
      ) {
        requiredFields.push('partner_company_branch_id');
        count = 1;
      }
    }

    this.setState({
      requiredInput: {
        ...this.state.requiredInput,

        // 必須入力項目
        columns: requiredFields,
        // 必須総数
        total: _.size(requiredFields),
        count, // 入力数
      },
    });

    this.schema = Joi.object().keys(this.schemaDefinition);
  }

  settingPermission = () => {
    return UsersApi.fetchCompanyUserPermissions(this.companyId, {
      buildee_manager_flg: 1,
    }).then(res => {
      let isManagerPermission = false;
      if (res.result === true) {
        if (res.data.total > 0) {
          const companyUserPermissions =
            res.data.entities.company_user_permissions;
          for (let permission of companyUserPermissions) {
            if (permission.user_id === Number(this.userId)) {
              isManagerPermission = true;
              break;
            }
          }
        }

        this.setState({
          isManagerPermission,
        });
      }
    });
  };

  /**
   * Get company detail for currently field tree node
   * @returns {Promise<void>}
   */
  getFieldTreeCompany = async () => {
    //会社情報
    ///api/private/fields/:field_id/field_trees/:id
    return FieldTreeService.showTree(
      this.state.field_id,
      this.state.field_tree_id
    ).then(response => {
      const fieldTree = _.get(response, 'data.entities.field_tree');
      if (response.result && fieldTree) {
        const formValues = _.cloneDeep(this.state.formValues);
        let partnerCompanyBranchPreviewName = HEAD_OFFICE_OPTION.name;
        if (fieldTree.partner_company_branch_block_flag) {
          formValues.partner_company_branch_id = HEAD_OFFICE_OPTION.id;
        } else if (fieldTree.partner_company_branch_name) {
          partnerCompanyBranchPreviewName =
            fieldTree.partner_company_branch_name;
        }
        this.initPartnerCompanyBranchId =
          formValues.partner_company_branch_id || HEAD_OFFICE_OPTION.id;
        this.setState({
          formValues: {
            ...formValues,
            ..._.pick(response.data.entities.field_tree, [
              'company_name',
              'company_id',
              'approval_flag',
            ]),
          },
          companyAddress:
            _.get(response.data.entities.field_tree, 'company.address') || '',
          partnerCompanyBranchPreviewName,
        });
      }
    });
  };

  /**
   * 入力
   */
  setData = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = value;

    // Handling for special case
    switch (name) {
      case 'tel1':
      case 'tel2':
      case 'tel3':
        formValues.tel = `${formValues.tel1}-${formValues.tel2}-${
          formValues.tel3
        }`;
        break;
      case 'field_tree_user_jobs':
        const jobIds = value.filter(x => x.job_id > 0).map(x => x.job_id);
        if (_.size(jobIds)) {
          formValues.job_id = jobIds;
        } else {
          delete formValues.job_id;
        }
        break;
    }

    const { messages: validateMessages = {} } = validateByJoi(
      this.schema,
      formValues
    );

    // 必須チェック
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    requiredInput.count = _.reduce(
      this.state.requiredInput.columns,
      (accum, item) => {
        if (
          item === 'partner_company_branch_id' ||
          (formValues[item] && !validateMessages[item])
        ) {
          accum++;
        }
        return accum;
      },
      0
    );

    this.setState({
      requiredInput,
      formValues,
    });
  };

  /**
   * 入力値の有効判定
   * @return bool
   */
  isValid = (e, targetName) => {
    const values = _.cloneDeep(this.state.formValues);
    const validate = _.cloneDeep(this.state.validate);
    const result = validateByJoi(this.schema, values);
    const available = result.result;

    // if  - onBlur時に入力チェック
    // else- submit(登録ボタン押下)時に必須項目チェック
    if (e) {
      const name = _.isEmpty(targetName) ? e.target.name : targetName;
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
      } else if (_.has(validate.messages, name)) {
        delete validate.messages[name];
      }
    } else {
      validate.messages = {};
      if (!available) {
        _.each(result.messages, (value, key) => {
          validate.messages[key] = result.messages[key];
        });
      }
    }

    // error有無チェック、フラグ変更
    if (Object.keys(validate.messages).length !== 0) {
      validate.invalid = true;
    } else {
      validate.invalid = false;
    }

    this.setState({ validate });
    return validate.invalid;
  };

  /**
   * 「保存」ボタンの処理（新規登録 or 更新）
   *
   * @memberof FieldTreePartnerUserForm
   */
  submit = () => {
    if (this.isValid() || this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    const json = _.cloneDeep(this.state.formValues);
    const paramItem = {};
    paramItem.role_code = parseInt(json.role_code); //数値がstringなのでintに変換する
    paramItem.company_id = this.state.company_id;
    paramItem.company_branch_id = this.state.company_branch_id;
    paramItem.partner_company_branch_id = parseInt(
      json.partner_company_branch_id
    );
    paramItem.name_sei = json.name_sei;
    paramItem.name_mei = json.name_mei;
    paramItem.kana_sei = json.kana_sei;
    paramItem.kana_mei = json.kana_mei;
    paramItem.email = json.email;
    paramItem.login_id = json.login_id;
    paramItem.tel = joinTel(json.tel1, json.tel2, json.tel3);

    //職種
    paramItem.field_tree_user_jobs = _.uniq(
      _.map(json.field_tree_user_jobs, item => parseInt(item.job_id)).filter(
        item => item > 0
      )
    ).map(item => ({ job_id: item }));

    // 職種未入力チェック
    if (_.size(paramItem.field_tree_user_jobs) === 0) {
      return;
    }

    const param = {
      user: {
        company_id: paramItem.company_id,
        company_branch_id: paramItem.company_branch_id,
        role_code: paramItem.role_code,
        role_name: roleIdToRoleName(paramItem.role_code),
        name_sei: paramItem.name_sei,
        name_mei: paramItem.name_mei,
        kana_sei: paramItem.kana_sei,
        kana_mei: paramItem.kana_mei,
        login_id: paramItem.login_id,
        email: paramItem.email,
        tel: paramItem.tel,
      },
      field_tree_user_jobs: paramItem.field_tree_user_jobs,
    };

    if (this.state.isManagerPermission) {
      param.user.partner_company_branch_id =
        paramItem.partner_company_branch_id;
    }

    if (this.state.user_id > 0) {
      // 更新
      this.updatingFlag = false;
      this.fetchPatch(param, json.id);
    } else {
      // 新規登録
      this.tempParamFetch = param;
      LoginUserGroupsService.checkDuplicateEmail({
        email: param.user.email,
        user_role_code: param.user.role_code,
        company_id: param.user.company_id,
        company_branch_id: param.user.company_branch_id,
      })
        .then(res => {
          if (res.result) {
            this.setState({ showConfirmExistedEmailDialog: true });
          } else {
            this.setState({ showConfirmation: true });
          }
        })
        .finally(() => {
          this.updatingFlag = false;
        });
    }
  };

  /**
   * 更新
   *
   * @param {*} param
   * @param {*} id
   * @memberof FieldTreePartnerUserForm
   */
  fetchPatch = (param, id) => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const _param = {
      name_sei: param.user.name_sei,
      name_mei: param.user.name_mei,
      kana_sei: param.user.kana_sei,
      kana_mei: param.user.kana_mei,
      tel: formatTel(param.user.tel),
      field_tree_user_jobs: param.field_tree_user_jobs,
    };
    //https://v2-dev.buildee.jp/apidocs/public/field_tree_users/update.html
    ///api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/:id
    FieldTreeService.updateForemanUser(
      this.state.field_id,
      this.state.field_tree_id,
      id,
      _param
    )
      .then(response => {
        if (response.result) {
          _dialogLoader.show(dialog.patchSuccess, {
            callback: {
              done: () => {
                _dialogLoader.close();
                masterSlideLoader.show(
                  'PartnerBox',
                  { state: { id: this.state.prev_id } },
                  '1'
                );
              },
            },
          });
        } else if (response.state !== 200) {
          let errorMessage = messageUtility.getMessage('E-000-001');
          _dialogLoader.show(FormInformationDialog, {
            onClose: () => {
              _dialogLoader.close();
            },
            title: messageUtility.getMessage('E-001-402'),
            message: errorMessage,
          });
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  /**
   * 新規登録
   *
   * @param {*} param
   * @memberof FieldTreePartnerUserForm
   */
  fetchPost = param => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    //https://v2-dev.buildee.jp/apidocs/public/field_tree_users/create.html
    ///api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users
    FieldTreeService.createForemanUser(
      this.state.field_id,
      this.state.field_tree_id,
      param
    )
      .then(response => {
        if (response.result) {
          _dialogLoader.show(dialog.submitSuccess, {
            callback: {
              done: () => {
                _dialogLoader.close();
                masterSlideLoader.show(
                  'PartnerBox',
                  { state: { id: this.state.prev_id } },
                  this.props.vw
                );
              },
            },
          });
        } else if (response.status !== 200) {
          // エラー時のメッセージ
          // errorに入ってないときは安全にデフォルトのエラーメッセージ
          let errorMessage = messageUtility.getMessage('E-000-001');
          if (_.has(response, 'data.message')) {
            errorMessage = response.data.message;
          }
          _dialogLoader.show(FormInformationDialog, {
            onClose: () => {
              _dialogLoader.close();
            },
            title: messageUtility.getMessage('E-001-402'),
            message: errorMessage,
          });
        }
      })
      .finally(() => {
        this.setState({
          showConfirmation: false,
        });
        this.updatingFlag = false;
      });
  };

  /**
   * 「編集をやめる」or右上のxボタン 押下
   *
   * @memberof FieldTreePartnerUserForm
   */
  close = () => {
    if (
      _.isNumber(this.state.data.user.role_code) &&
      isPartnerRoleId(this.state.data.user.role_code)
    ) {
      // 協力会社管理者か職長で、協力会社管理者の場合
      // ダイアログを表示せずに画面を閉じる

      masterSlideLoader.show(
        'PartnerBox',
        { state: { id: this.state.prev_id } },
        this.props.vw
      );

      return;
    }

    // 閉じる前の確認ダイアログ表示
    _dialogLoader.show(dialog.CloseEditView, {
      callback: {
        close: () => {
          _dialogLoader.close();
        },
        clear: () => {
          _dialogLoader.close();
          masterSlideLoader.show(
            'PartnerBox',
            { state: { id: this.state.prev_id } },
            this.props.vw
          );
        },
      },
    });
  };

  closeDialog = stateName => {
    this.setState({ [stateName]: false });
    if (this.tempParamFetch) {
      this.tempParamFetch = null;
    }
    if (stateName === 'showInformationModal' && this.state.informationModal) {
      masterSlideLoader.show(
        'PartnerBox',
        { state: { id: this.state.prev_id } },
        this.props.vw
      );
    }
  };

  handlePartnerCompanyBranchDropdownChange = id => {
    this.setData('partner_company_branch_id', id);
  };

  confirmSubmit = () => {
    this.fetchPost(this.tempParamFetch);
    this.tempParamFetch = null;
  };

  confirmIntegrate = () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    LoginUserGroupsService.checkIntegrate({
      email: this.tempParamFetch.user.email,
      user_role_code: this.tempParamFetch.user.role_code,
      company_id: this.tempParamFetch.user.company_id,
      company_branch_id: this.tempParamFetch.user.company_branch_id,
    })
      .then(res => {
        if (res.result) {
          this.setState({
            listIntegrateUsers: _.get(res, 'data.entities.users'),
            showConfirmExistedEmailDialog: false,
            showConfirmIntegrateUserDialog: true,
          });
        } else {
          this.setState({
            integrateErrorMessage:
              _.get(res, 'data.message') ||
              messageUtility.getMessage('E-000-001'),
            showConfirmExistedEmailDialog: false,
            showIntegrateError: true,
          });
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  confirmIntegrateUser = () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    FieldTreeService.createIntegrate(
      this.state.field_id,
      this.state.field_tree_id,
      this.tempParamFetch
    )
      .then(res => {
        let informationModal = null;
        if (res.result) {
          EventManager.trigger(EventType.REFRESH_PROFILE);
          informationModal = {
            title: INTEGRATE_USER_SUCCESS_TITLE,
            message: INTEGRATE_USER_SUCCESS_MESSAGE,
          };
        }
        this.setState({
          showInformationModal: true,
          informationModal,
        });
      })
      .finally(() => {
        this.closeDialog('showConfirmIntegrateUserDialog');
        this.updatingFlag = false;
      });
  };

  render() {
    const title = () => {
      if (this.state.user_id > 0) {
        if (this.state.data.user) {
          return `${this.state.data.user.name_sei}${
            this.state.data.user.name_mei
          } 確認・編集`;
        } else {
          return ``;
        }
      } else {
        return `新規作成`;
      }
    };

    /**
     * 「削除」ボタンを非表示にするか
     * 非表示ならtrue
     *
     * @returns
     */
    const hideDeleteButtonStyle = () => {
      const role_id = parseInt(LocalStorageService.getItem('role_id'), 10);
      const user_id = parseInt(LocalStorageService.getItem('user_id'), 10);

      // 新規
      if (this.isNewMode) {
        return true;
      }

      // 自分は削除できない
      if (this.state.user_id === user_id) {
        return true;
      }

      // 自分のロール以下は削除できる
      if (this.state.role_id >= role_id) {
        return true;
      }

      return false;
    };

    return (
      <div className='master-slide-view show sys-splitview-1'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 施工体系図</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader title={title()} onClose={() => this.close()} />
          <div className='fieldstree-main'>
            <div className='fieldstree-main__menu fieldstree-main__under-bar'>
              <ul className='btn-menu'>
                <li
                  className='btn-menu__item'
                  style={this.isNewMode ? { display: 'none' } : {}}
                >
                  <button
                    className='btn--sub'
                    onClick={() => {
                      this.close();
                    }}
                  >
                    編集をやめる
                  </button>
                </li>
                {/* 削除ボタン */}
                <li
                  className='btn-menu__item'
                  style={hideDeleteButtonStyle() ? { display: 'none' } : {}}
                >
                  <button
                    className='btn--negative'
                    onClick={() => {
                      _dialogLoader.show(dialog.DeletePartnerCompanyUser, {
                        callback: {
                          close: () => {
                            _dialogLoader.close();
                          },
                          delete: async () => {
                            let param = {
                              user_ids: [_.clone(this.state.data.user.user_id)],
                            };
                            const response = await api.PartnerUserDelete(
                              this.state.field_id,
                              this.state.field_tree_id,
                              param
                            );
                            this.errorMessage = response.message;
                            if (response.result === true) {
                              EventMg.trigger(
                                FIELD_TREE_PARTNER_BOX.REFRESH_LIST
                              );
                              _dialogLoader.close();
                              masterSlideLoader.show(
                                'PartnerBox',
                                { state: { id: this.state.prev_id } },
                                this.props.vw
                              );
                            } else if (response.result === false) {
                              _dialogLoader.show(
                                dialog.NotDeletePartnerCompanyUser,
                                {
                                  message: this.errorMessage,
                                  callback: {
                                    close: () => {
                                      _dialogLoader.close();
                                    },
                                  },
                                }
                              );
                            }
                          },
                        },
                      });
                    }}
                  >
                    削除
                  </button>
                </li>
                {/* 職長の場合のみ保存ボタン表示 */}
                {_.isNumber(this.state.data.user.role_code) &&
                isForemanRoleId(this.state.data.user.role_code) ? (
                  <li className='btn-menu__item'>
                    <button
                      className='btn--effective'
                      onClick={() => {
                        this.submit();
                      }}
                    >
                      保存
                    </button>
                  </li>
                ) : (
                  ''
                )}
                <li className='btn-menu__item --fx-auto' />
                {/* 職長の場合のみ入力数の表示 */}
                {_.isNumber(this.state.data.user.role_code) &&
                isForemanRoleId(this.state.data.user.role_code) ? (
                  <li className='btn-menu__item'>
                    <p className='slide-view__header-end-item'>
                      必須項目の入力数
                      <span className='sys-required'>
                        {' '}
                        {this.state.requiredInput.count}
                      </span>
                      /
                      <span className='sys-required_total'>
                        {this.state.requiredInput.total}
                      </span>
                    </p>
                  </li>
                ) : (
                  ''
                )}
              </ul>
            </div>
          </div>
          <div className='fieldstree-main__content'>
            <div className='slide-view__view'>
              <div className='slide-view__body'>
                <TreePartnerUserForm
                  fieldId={this.state.field_id}
                  values={this.state.formValues}
                  disabledFields={this.state.disabledFields}
                  forms={this.form}
                  messages={this.state.validate.messages}
                  newMode={this.isNewMode}
                  onSelect={this.handlePartnerCompanyBranchDropdownChange}
                  isManagerPermission={this.state.isManagerPermission}
                  isTargetRoleId={this.isTargetRoleId}
                  partnerCompanyBranchPreviewName={
                    this.state.partnerCompanyBranchPreviewName
                  }
                  initPartnerCompanyBranchId={this.initPartnerCompanyBranchId}
                />
              </div>
            </div>
          </div>
        </div>
        <ForemanRegistConfirmDialog
          visible={this.state.showConfirmation}
          onCancel={() => this.closeDialog('showConfirmation')}
          onConfirm={this.confirmSubmit}
          companyName={this.state.formValues.company_name}
          companyAddress={this.state.companyAddress}
          values={this.state.formValues}
        />
        <ConfirmExistedEmailDialog
          visible={this.state.showConfirmExistedEmailDialog}
          isCreateNew={this.isNewMode}
          userRoleCode={this.state.formValues.role_code}
          onCancel={() => this.closeDialog('showConfirmExistedEmailDialog')}
          onConfirmIntegrate={this.confirmIntegrate}
          onConfirmNotIntegrate={() => {
            this.setState({
              showConfirmExistedEmailDialog: false,
              showConfirmation: true,
            });
          }}
        />
        <ConfirmIntegrateUserDialog
          visible={this.state.showConfirmIntegrateUserDialog}
          onConfirm={this.confirmIntegrateUser}
          data={this.state.listIntegrateUsers}
          onCancel={() => this.closeDialog('showConfirmIntegrateUserDialog')}
        />
        <IntegrateError
          visible={this.state.showIntegrateError}
          isCreateNew={this.isNewMode}
          userRoleCode={this.state.formValues.role_code}
          reason={this.state.integrateErrorMessage}
          onCancel={() => this.closeDialog('showIntegrateError')}
          onConfirm={() => {
            this.setState({
              showIntegrateError: false,
              showConfirmation: true,
            });
          }}
        />
        <Information
          title={messageUtility.getMessage('E-001-402')}
          message={INTEGRATE_USER_COMMON_ERROR_MESSAGE}
          {...this.state.informationModal}
          visible={this.state.showInformationModal}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.closeDialog('showInformationModal')}
          multilineText={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldTreePartnerUserForm.jsx